function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2187 26.0038C16.2187 26.3505 16.4673 26.6342 16.7671 26.6342H30.2934C30.5932 26.6342 30.8418 26.3505 30.8418 26.0038V24.3522C30.8418 24.0054 30.5932 23.7217 30.2934 23.7217H16.7671C16.4673 23.7217 16.2187 24.0054 16.2187 24.3522V26.0038ZM1.01077 26.4845L16.0067 13.7975C16.2845 13.5454 16.2845 13.0805 16.0067 12.8283L1.01077 0.149224C0.926029 0.0715547 1.12101 0.0217276 1.01077 0.00565511C0.900535 -0.0104174 1.11162 0.00794057 1.01077 0.0585514C0.909928 0.109162 1.07031 0.189898 1.01077 0.291175C0.951236 0.392453 1.01016 0.510018 1.01077 0.629911V4.50534C1.01077 4.69446 0.871855 4.86782 1.01077 4.98602L11.3817 13.3169L1.01077 21.6477C0.945421 21.7067 1.04737 21.7801 1.01077 21.8631C0.974181 21.946 1.01194 22.0365 1.01077 22.1284V26.0038C1.01077 26.5397 0.630575 26.8312 1.01077 26.4845Z",
  fill: "currentColor"
});

var SvgIcSidemenuTesting = function SvgIcSidemenuTesting(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcSidemenuTesting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_sidemenu_testing.3c04c647.svg";
export { ForwardRef as ReactComponent };